module.exports = __webpack_public_path__ + "logo.a961dfbf36f110092c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 1190
// module chunks = 6